@if (visible()) {
  <div class="export-progress-panel">
    <div class="export-progress-header">
      <span class="text-sm font-semibold">Exporting Survey</span>
      <p-button
        icon="pi pi-times"
        [text]="true"
        [rounded]="true"
        severity="secondary"
        [style]="{ width: '1.5rem', height: '1.5rem' }"
        (onClick)="close()"
      />
    </div>
    
    <div class="export-progress-content">
      <p class="mb-2 text-sm">{{ getStatusText() }}</p>
      
      <p-progressBar 
        [value]="progress()" 
        [showValue]="false"
        [style]="{ height: '8px' }"
      ></p-progressBar>
      
      <p class="mt-2 text-xs text-500">{{ progress() }}%</p>
    </div>
  </div>
}
